import { type LayoutSolutionAgencyConfiguration, type LayoutSolutionRequest } from '@/types';

export interface Dictionary<T> {
  [key: string]: T;
}

export const isLayoutSolutionActive = (query: Dictionary<string | (string | null)[]>): boolean =>
  !!query && ['l', 'a', 'incsubs'].some((param) => Object.hasOwnProperty.call(query, param));

export const HOMEGATE_AGENCY = 'default';

export const getLayoutSolutionRequest = (
  query: Dictionary<string | (string | null)[]>,
): LayoutSolutionRequest | undefined => {
  if (isLayoutSolutionActive(query)) {
    return {
      agency: (query.a || HOMEGATE_AGENCY) as string,
      layout: (query.layout || 'neutral') as string,
      includeSubAgencies: query.incsubs === '1',
      withSearchbar: query.sb === '1',
    };
  }
};

export function getLayoutSolutionRequestQueryParameters(
  request?: LayoutSolutionRequest,
): Record<string, string> {
  if (request) {
    return {
      l: request.layout,
      ...(request.agency !== HOMEGATE_AGENCY && { a: request.agency }),
      ...(request.includeSubAgencies && { incsubs: '1' }),
      ...(request.withSearchbar && { sb: '1' }),
    };
  }

  return {};
}

export const getLayoutSolutionAgencyConfiguration = (
  configurations: Record<string, LayoutSolutionAgencyConfiguration>,
  agency: string,
): LayoutSolutionAgencyConfiguration | undefined => configurations[agency];
